import { trigger } from "./event";
export var isSelect = function isSelect(e) {
  if (e === null) return false;
  return e instanceof HTMLSelectElement;
};
export var isInput = function isInput(e) {
  if (e === null) return false;
  return e instanceof HTMLInputElement;
};
export var isTextarea = function isTextarea(e) {
  if (e === null) return false;
  return e instanceof HTMLTextAreaElement;
};
export var update = function update(input, value) {
  var skipTrigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!input) return;
  if (!isInput(input) && !isTextarea(input)) return;
  change({
    e: input,
    value: value,
    skipTrigger: skipTrigger
  });
};
export var hasValue = function hasValue(select, value) {
  if (value === null) return false;
  return select.querySelector("[value=\"".concat(value, "\"]")) !== null;
};

var updateSelect = function updateSelect(_ref) {
  var e = _ref.e,
      value = _ref.value,
      skipTrigger = _ref.skipTrigger;
  if (value === null) return;
  if (!isSelect(e)) return;
  setValue(e, value);
  if (!skipTrigger) trigger(e, "select");
  trigger(e, "change");
};

export var setValue = function setValue(e, value) {
  var descriptor = Object.getOwnPropertyDescriptor(e.constructor.prototype, "value");
  if (descriptor === undefined) return;
  if (descriptor.set === undefined) return;
  var setter = descriptor.set;
  setter.call(e, value);
};

var updateInput = function updateInput(_ref2) {
  var e = _ref2.e,
      value = _ref2.value,
      skipTrigger = _ref2.skipTrigger;
  if (value === null) return;
  if (!isInput(e) && !isTextarea(e)) return;
  setValue(e, value);
  if (!skipTrigger) trigger(e, "input");
  trigger(e, "change");
};

export var change = function change(options) {
  if (options.value === null) return;
  updateSelect(options);
  updateInput(options);
};